import styled from 'styled-components';

export const ButtonContainer = styled.div`
  background-color: ${Styles.color.white};
  bottom: 0;
  position: relative;
  width: 100%;
`;
